import { memo, useState } from 'react'

import { PartnerFields } from 'clickNgo/entities/partner/configs'
import { FormCheckBox } from 'cng-common/features/form'
import { FieldGroup } from 'shared/components/fieldGroup/FieldGroup'
import { LinkList } from 'shared/components/linkList/LinkList'

import { partnerAdditionalTranslation } from '../../translation'

import { ILinksBlockProps } from './models'

import styles from './LinksBlock.module.scss'

export const LinksBlock = memo<ILinksBlockProps>(
  ({
    formKeys,
    isDisabled,
    isReadOnly,
    ecommerceLinks,
    socialMediaLinks,
    hasNotOnlineCommerce,
  }) => {
    const [localHasNotOnlineCommerce, setLocalHasNotOnlineCommerce] = useState(hasNotOnlineCommerce)

    return (
      <FieldGroup
        title={partnerAdditionalTranslation.content.blockTitles.linksBlock}
        classNames={{ groupFields: styles.fieldGroup }}
      >
        <FormCheckBox
          className={styles.hasNotOnlineCommerce}
          defaultValue={hasNotOnlineCommerce}
          field={PartnerFields.hasNotOnlineCommerce.field}
          label={PartnerFields.hasNotOnlineCommerce.label}
          formKey={formKeys.additional}
          onChange={setLocalHasNotOnlineCommerce}
          isDisabled={isDisabled}
          isReadOnly={isReadOnly}
        />
        {localHasNotOnlineCommerce || (
          <LinkList
            isDisabled={isDisabled}
            isReadOnly={isReadOnly}
            field={PartnerFields.ecommerceLinks.field}
            label={PartnerFields.ecommerceLinks.label}
            formKey={formKeys.additional}
            defaultValue={ecommerceLinks}
          />
        )}
        <LinkList
          isDisabled={isDisabled}
          isReadOnly={isReadOnly}
          field={PartnerFields.socialMediaLinks.field}
          label={PartnerFields.socialMediaLinks.label}
          formKey={formKeys.additional}
          defaultValue={socialMediaLinks}
        />
      </FieldGroup>
    )
  }
)
